import { VParcelIdentificationRemote } from "../api/land-pacel";
import { VParcelIdentification } from "../common/land-parcel";

export function mapVParcelIdentificationRemoteToDomain(remote: VParcelIdentificationRemote): VParcelIdentification {
  return {
    landParcelName: remote.land_parcel_name,
    coordinateReferencySystem: remote.coordinate_ref_system,
    points: remote.points
      .map(p => ({ lat: Number(p.lat), lng: Number(p.lng) }))
      .filter(p => p.lat != null && p.lng != null)
      .map(p => ({ latitude: p.lat, longitude: p.lng })),
    planningStatus: remote.planning_status,
    qualityOfSoil: remote.qos_degradation,
    environmentalConsideration: remote.env_consideration,
    otherConsideration: remote.other_consideration,
    landAreas: remote.land_areas
  }
}